import React, { useEffect, useState } from "react";
import { DefaultIndex } from "../../../components/extras/DefaultIndex";
import { fetchWithWatch } from "../../../hooks/fetchWithWatch";
import { getCookie, getUrlVersion } from "../../commons/functions";
const _preserve = React.version;

export const BreadPage = () => {
  // Local state used only to force a re-render
  const [hash, setHash] = useState(window.location.hash);

  useEffect(() => {
    const handleHashChange = () => {
      setHash(window.location.hash); // updates state → re-renders component
    };
    handleRefresh()
    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  const handleRefresh = async () => {
    try {
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/?REFRESH`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/user/login/data',
          'JWT': getCookie("JWT"),
        },
        body: JSON.stringify({}),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const dataTmp = await response.json();

    } catch (error: any) {
      console.error(error);
    } finally {
    }
  }
  return <DefaultIndex key={hash} />; // optional: key forces remount on change
};
